import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { CANT_RECOGNISE_NUMBER_SHOWN, CHANGE_PHONE_COUNTRY_CLICKED, REENTER_MANUALLY_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PHONE_COUNTRY } from 'apps/auth/constants/FieldType';
import { resolveArguments } from 'apps/auth/helpers/utils';

const PhoneInputErrorPopup = (props) => {
    useEffect(() => {
        sendEvent(CANT_RECOGNISE_NUMBER_SHOWN);
    }, []);

    const sendEvent = (eventName) => {
        amplitude.getInstance().logEvent(eventName, { [PHONE_COUNTRY]: props.countryName });
    };

    return (
        <SimplePopup
            popupRef={props.popupRef}
            text={
                <div>
                    <p>{resolveArguments(props.text1, [props.countryName, props.formattedNumber || `${props.prefix} ${props.userInputWithoutPrefix}`])}</p>
                    <p>{props.text2}</p>
                </div>
            }
        >
            <PopupButton
                iconName="retry"
                text={props.changeCountryButton}
                onClick={(e) => {
                    sendEvent(CHANGE_PHONE_COUNTRY_CLICKED);
                    props.popupRef.current?.close();
                    e.preventDefault();
                    props.showCountryModal();
                }}
            />
            <PopupButton
                iconName="dialpad"
                text={props.reenterManuallyButton}
                onClick={() => {
                    sendEvent(REENTER_MANUALLY_CLICKED);
                    props.popupRef.current?.close();
                }}
            />
        </SimplePopup>
    );
};

PhoneInputErrorPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    text1: PropTypes.string,
    text2: PropTypes.string,
    changeCountryButton: PropTypes.string,
    reenterManuallyButton: PropTypes.string,
    countryName: PropTypes.string,
    countryCode: PropTypes.string,
    prefix: PropTypes.string,
    userInputWithoutPrefix: PropTypes.string,
    formattedNumber: PropTypes.string,
};

export default PhoneInputErrorPopup;
